export function resolveVideoSrc(media, width) {
  if (width >= 1080) {
    return media.sources.find((src) => src.height >= 1080 && src.format === "mp4");
  }
  if (width >= 720) {
    return media.sources.find(
      (src) => src.height < 1080 && src.height > 480 && src.format === "mp4"
    );
  }
  return media.sources.find((src) => src.height <= 480 && src.format === "mp4");
}
